import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { withLatestFrom } from 'rxjs/operators';

import { AccountSelectors, CurrentUserSelectors } from '@recruitee/account-data';
import { filterBoolean } from '@recruitee/common';
import { DevFlag, DevFlagSelectors } from '@recruitee/dev-flags-data';
import { AuthService } from '@recruitee/http';
import { IntercomService } from '@recruitee/intercom-integration';

@Injectable({ providedIn: 'root' })
export class Account {
  constructor(
    private authService: AuthService,
    private intercomService: IntercomService,
    private store: Store,
  ) {
    this.store
      .select(AccountSelectors.currentCompany)
      .pipe(
        filterBoolean,
        withLatestFrom(
          this.store.select(CurrentUserSelectors.data),
          this.store.select(DevFlagSelectors.isEnabled(DevFlag.EventDebug)),
        ),
      )
      .subscribe(([currentCompany, currentAdmin, debugEventTracking]) =>
        this.intercomService.init(currentCompany, currentAdmin!, debugEventTracking),
      );
  }

  public signOut(afterSignOutUrl?: string): void {
    this.intercomService.shutdown();
    this.authService.clearAccessToken();
    this.authService.redirectToSignOut(afterSignOutUrl);
  }
}
